<div class="in-line-control">
  <div class="table-header">
    @if (totalItems > -1) {
      <div class="resources-amount">
        {{ 'common.found' | labelsProvider }} {{ totalItems | number }}
        {{ 'inLineControl' }}
      </div>
    }
  </div>
  <div class="table">
    <app-prime-table
      #table
      class="table-component"
      queryParamProperty="in-line-control"
      [data$]="inLineControlCurrentPage$"
      [rowsPerPage]="defaultPageSize"
      [pageInfo]="pageInfo$.value"
      [columns]="columns()"
      [isLoading]="isLoading()"
      [withActions]="false"
      [sortedColumn$]="sortedColumn$"
      [withCheckboxSelection]="false"
      [tabelWithIcon]="false"
      tableNotFoundText="You don't have any in line control data"
      tableNotFoundIcon="assets/images/common/no-results-found.svg"
    />
  </div>
</div>
